import styled from "@emotion/styled";
import * as Dialog from "@radix-ui/react-dialog";

export const CenteredContent = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 16px;
    z-index: 1100;
    contain: layout paint;
`;

export const ModalBody = styled.div`
    width: 280px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #26282d;
    border-radius: 12px;
    padding: 16px;
    border: 1px solid #2b2d33;
`;

export const Title = styled.h3`
    margin: 0;
    font-family: Inter;
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 16px;
    line-height: 100%;
    color: #e9ecf5;
`;

export const Section = styled.button`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 6px 8px;
    background: transparent;
    border: 0;
    text-align: left;
    cursor: pointer;
    border-radius: 8px;

    &:hover {
        background: rgba(255, 255, 255, 0.04);
    }
`;

export const SectionHeading = styled.div`
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    line-height: 100%;
    color: #e9ecf5;
`;

export const SectionBody = styled.div<{ dim?: boolean }>`
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    line-height: ${(p) => (p.dim ? "140%" : "100%")};
    color: #b7bdcb;
`;

export const CancelButton = styled.button`
    height: 36px;
    display: grid;
    place-items: center;
    width: 100%;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    line-height: 140%;
    text-align: center;
    color: #b7bdcb;
`;
